<section class="section section--paper close" id="watchlist">
  <div class="wrap">
    <div class="grid">
      <div>
        <span class="eyebrow close-eyebrow">The Watchlist</span>
        <p class="stmt">The Register is not finished, and that is the point.</p>
        <p class="close-copy">Twice a year a new series is issued and a handful of names become possible for
          the first time. Plates held for decades come back to the market without warning. Put a name on
          your watchlist and we will email you when a registration for it appears or comes to market.</p>
      </div>
      <form class="reg-form" (ngSubmit)="submit()">
        <div class="fld">
          <label for="watchName">The name you are watching</label>
          <input id="watchName" type="text" placeholder="e.g. Matilda" autocomplete="off"
                 autocapitalize="words" [(ngModel)]="watchName" name="watchName"/>
        </div>
        <div class="fld">
          <label for="watchEmail">Email</label>
          <input id="watchEmail" type="email" placeholder="you@example.com" autocomplete="email"
                 [(ngModel)]="watchEmail" name="watchEmail"/>
        </div>
        <button type="submit" class="btn btn--green watch-submit"
                [disabled]="status === 'checking' || status === 'saving'">
          {{ status === 'checking' || status === 'saving' ? 'Adding…' : 'Add to my watchlist' }}
        </button>
        <p class="watch-msg" role="status" aria-live="polite"
           [class.ok]="status === 'added'"
           [class.warn]="status === 'duplicate'"
           [class.err]="status === 'error' || status === 'invalid' || status === 'unwritable'"
           *ngIf="message">{{ message }}</p>
      </form>
    </div>
  </div>
</section>
